import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
let UserInvoiceSettingModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = belongsTo('contact', {
  inverse: 'user_invoice_setting',
  async: false
}), _dec7 = attr('boolean'), _dec8 = attr('boolean'), _dec9 = attr('string'), _dec0 = attr('string'), _dec1 = attr('string'), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = attr('string'), _dec13 = attr('string'), _dec14 = attr('string'), _dec15 = attr('boolean', {
  defaultValue: false
}), _class = class UserInvoiceSettingModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "bank_name", _descriptor, this);
    _initializerDefineProperty(this, "bank_iban", _descriptor2, this);
    _initializerDefineProperty(this, "bank_bic", _descriptor3, this);
    _initializerDefineProperty(this, "rea", _descriptor4, this);
    _initializerDefineProperty(this, "regime_fiscale", _descriptor5, this);
    _initializerDefineProperty(this, "contact", _descriptor6, this);
    _initializerDefineProperty(this, "ts_enable", _descriptor7, this);
    _initializerDefineProperty(this, "ts_struttura", _descriptor8, this);
    _initializerDefineProperty(this, "ts_codssa", _descriptor9, this);
    _initializerDefineProperty(this, "ts_codasl", _descriptor0, this);
    _initializerDefineProperty(this, "ts_codregione", _descriptor1, this);
    _initializerDefineProperty(this, "ts_pincode", _descriptor10, this);
    _initializerDefineProperty(this, "ts_pwd", _descriptor11, this);
    _initializerDefineProperty(this, "ts_username", _descriptor12, this);
    _initializerDefineProperty(this, "ts_tipo_spesa", _descriptor13, this);
    _initializerDefineProperty(this, "ts_cod_fiscale", _descriptor14, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor15, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "bank_name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bank_iban", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bank_bic", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "rea", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "regime_fiscale", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "contact", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "ts_enable", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "ts_struttura", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "ts_codssa", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "ts_codasl", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "ts_codregione", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "ts_pincode", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "ts_pwd", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "ts_username", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "ts_tipo_spesa", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "ts_cod_fiscale", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { UserInvoiceSettingModel as default };
//# sourceMappingURL=user-invoice-setting.js.map
